import React from 'react'
import { Box, Typography } from '@mui/material'
import { PassengerBaggage } from '@/src/types/flight'
import { useTranslations } from 'next-intl'
import { BaggageComponent } from './baggageComponent'
import DotsWaveLoader from './bagaggeDotWaveLoader'
import { Work } from '@mui/icons-material'
import BaggageRetryButton from '@/src/components/common/ui/BaggageRetryButton'
type BaggageDetailsProps = {
    baggageData: PassengerBaggage | null
    loading: boolean
    error: string | null
    retryCount: number
    handleRetryBaggage: () => void
    maxRetries: number
}

const BaggageDetails: React.FC<BaggageDetailsProps> = ({ 
    error, 
    baggageData, 
    loading, 
    retryCount,
    handleRetryBaggage,
    maxRetries 
}) => {
    const tCommon = useTranslations('common');
    const tFlightDetails = useTranslations('srpFlightDetails');

    if(loading) {
        return <DotsWaveLoader />
    }
    
    // Show retry button if error and retries available
    if ((error || !baggageData || !baggageData.cib || !baggageData.cab) && retryCount < maxRetries) {
        return <BaggageRetryButton onRetry={handleRetryBaggage} />
    }
    
    return (
        <Box>
            {
                !baggageData?.cib && !baggageData?.cab ? 
                <Typography variant="caption" fontWeight="bold" sx={{ ml: 0.5, fontSize: '10px', display: 'flex', alignItems: 'center' }}>
                    <Work sx={{ fontSize: 16, color: '#9ca3af', mr: 0.5 }} />
                    {tCommon("baggage")} : {tFlightDetails('baggageFailureNote')}
                </Typography> :
            <>
            <BaggageComponent 
                baggage={baggageData?.cib ? baggageData?.cib : null} 
                checkin={true} 
            />
            <BaggageComponent 
                baggage={baggageData?.cab ? baggageData?.cab : null} 
                checkin={false} 
            />
            </>
}
        </Box>
    )
}

export default BaggageDetails